import { LegalPage } from '@/components/LegalPage';

export function CookiesPage() {
  return (
    <LegalPage
      title="Cookie Choices"
      updated="June 18, 2026"
      intro="BingeBox keeps cookies to a minimum — we use them to run the service, not to track you across the web."
    >
      <h2>What we use</h2>
      <ul>
        <li>
          <strong>Essential cookies</strong> — a secure, HTTP-only session cookie that keeps you
          signed in. The Service can't work without it, so it can't be turned off.
        </li>
        <li>
          <strong>Preferences</strong> — small bits of local storage remember things like dismissed
          banners and your last view.
        </li>
      </ul>

      <h2>What we don't use</h2>
      <p>
        We don't run third-party advertising or cross-site tracking cookies. Payment pages are
        served by Stripe, which sets its own cookies needed to process payments securely.
      </p>

      <h2>Managing cookies</h2>
      <p>
        You can clear or block cookies in your browser settings. Note that blocking the essential
        session cookie will sign you out and prevent playback of full episodes.
      </p>
    </LegalPage>
  );
}
